import React, { useState, useEffect, useCallback } from 'react';
import useUserBuffStore from '../store/userBuffStore';
import './UserListBuff.css';
import '../Components/buffs/Buffs.css';

function formatFullTime(duration) {
    if (duration === -1) return '∞';
    const minutes = Math.floor(duration / (1000 * 60));
    const seconds = Math.floor((duration % (1000 * 60)) / 1000);
    if (minutes >= 1) {
        return `${minutes}m ${seconds.toString().padStart(2, '0')}s`;
    } else {
        return `${seconds}s`;
    }
}

function ToolTip({ position, buff, remainingTime }) {
    if (!position) return null;
    return (
        <div 
            className="tooltip" 
            style={{ 
                left: `${position.x}px`, 
                top: `${position.y}px`,
                position: 'fixed'
            }}
        >
            <h3>{buff.name}</h3>
            {buff.description.split('<br>').map((text, index) => (
                <p key={index}>{text}</p>
            ))}
            <span className="tooltip-time">[{formatFullTime(remainingTime)}]</span>
        </div>
    );
}

function UserListBuff({ buff }) {
    const [tooltipPosition, setTooltipPosition] = useState(null);
    const formatRemainingTime = useUserBuffStore((state) => state.formatRemainingTime);
    const getBuffRemainingTime = useUserBuffStore((state) => state.getBuffRemainingTime);

    // Tooltip logic
    const handleMouseMove = useCallback((e) => {
        const nearBottomEdge = window.innerHeight - e.clientY < 150;
        setTooltipPosition({
            x: Math.min(e.clientX + 15, window.innerWidth - 220),
            y: nearBottomEdge ? e.clientY - 15 : e.clientY + 20
        });
    }, []);
    const handleMouseLeave = useCallback(() => {
        setTooltipPosition(null);
    }, []);

    // Don't render if buff is expired (let server handle removal)
    const isExpired = getBuffRemainingTime(buff) <= 0;

    return (
        <div 
            className={`user-list-buff ${buff.isDebuff ? 'debuff' : 'buff'} ${isExpired ? 'expired' : ''}`}
            onMouseMove={handleMouseMove}
            onMouseLeave={handleMouseLeave}
        >
            <img 
                src={require(`../Assets/gfx/${buff.picId}.webp`)} 
                alt={buff.shortName}
                onError={(e) => {
                    e.target.src = require('../Assets/gfx/1.webp');
                }}
            />
            <ToolTip position={tooltipPosition} buff={buff} remainingTime={getBuffRemainingTime(buff)} />
        </div>
    );
}

export default UserListBuff; 